import Duck from 'custom-redux-ducks-ts'

export const login = new Duck('login', 'eduprivada')
export const googleLogin = new Duck('googleLogin', 'eduprivada')
export const facebookLogin = new Duck('facebookLogin', 'eduprivada')